import { render, staticRenderFns } from "./harmfulFactorsDeptManage.vue?vue&type=template&id=1afc7db0"
import script from "./harmfulFactorsDeptManage.vue?vue&type=script&lang=js"
export * from "./harmfulFactorsDeptManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afc7db0')) {
      api.createRecord('1afc7db0', component.options)
    } else {
      api.reload('1afc7db0', component.options)
    }
    module.hot.accept("./harmfulFactorsDeptManage.vue?vue&type=template&id=1afc7db0", function () {
      api.rerender('1afc7db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/harmfulFactorsDeptManage.vue"
export default component.exports